module.exports = __webpack_public_path__ + "img/check.e3e0a21b.svg";